var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Recommend"},[_c('p',{staticClass:"othersCx"},[_vm._v(" 为你推荐： "),_vm._l((_vm.recommendWords),function(word,index){return _c('a',{key:index,attrs:{"href":"javascript:;"},on:{"click":function($event){_vm.forSearch(word);_vm.countAd(4518)}}},[_vm._v(_vm._s(word))])})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }